import { bool, func } from 'prop-types';
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const CloneConfirmation = ({ toggle, setToggle, onClick }) => {
  return (
    <Modal isOpen={toggle} toggle={setToggle} size="md">
      <ModalHeader toggle={setToggle}>Confirm Clone</ModalHeader>
      <ModalBody>
        When an opportunity is cloned, the free budget and the Commercial
        Incentive will be removed and will not be transferred to the newly
        cloned opportunity. Make sure to modify the new opportunity&apos;s quote
        before finalizing the campaign.
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onClick}>
          Yes
        </Button>
        <Button color="secondary" onClick={setToggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

CloneConfirmation.propTypes = {
  toggle: bool.isRequired,
  setToggle: func.isRequired,
  onClick: func.isRequired,
};

export default CloneConfirmation;
